<template>
    <td class="py-2 lg:py-4 px-8 block lg:table-cell">
        <slot></slot>
    </td>
</template>
